import React, { ButtonHTMLAttributes, forwardRef } from 'react';

import { FontIcons } from '@components/library/icon';
import BaseButton, { ButtonLoaderColors } from '../BaseButton';
import styleClassNames from './styles.module.scss';

interface PrimaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: string | FontIcons;
  iconSize?: number;
  isLoading?: boolean;
  loadingCopy?: string;
  loadingIcon?: string | FontIcons;
  loadingIconSize?: number;
  size?: ButtonSize;
}

type ButtonSize = 'xsmall' | 'small' | 'medium' | 'large';

const PrimaryButton = forwardRef<HTMLButtonElement, PrimaryButtonProps>((props, ref) => {
  const baseProps = {
    ...props,
    buttonLoaderColor: 'white' as ButtonLoaderColors,
    styleClassNames,
    variantName: 'primary',
  };

  return <BaseButton {...baseProps} ref={ref} />;
});

export default PrimaryButton;
